import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserUpdateDto } from '../dtos/user/userUpdateDto';
import { UserCreateDto } from '../dtos/user/userCreateDto';


@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient) { }

  public apiUrl = `${environment.apiUrl}/users`;

  getList(): Observable<any> {
    return this.http.get(`${this.apiUrl}`)
  }

  getById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`)
  }

  create(userCreateDto: UserCreateDto) {
    return this.http.post(`${this.apiUrl}`, userCreateDto)
  }

  update(id: number, userUpdateDto: UserUpdateDto) {
    return this.http.put(`${this.apiUrl}/${id}`, userUpdateDto)
  }

  delete(id: number) {
    return this.http.delete(`${this.apiUrl}/${id}`)
  }


  renewPassword(id: number) {
    return this.http.put(`${this.apiUrl}/RenewPassword/${id}`, null)
  }

  getUsers(): Observable<any> {
    return this.http.get(`${this.apiUrl}/getUsers`)
  }
}
